import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "row my-3" }
const _hoisted_2 = { class: "col-lg-3" }
const _hoisted_3 = {
  key: 0,
  class: "bg-secondary text-white ms-n3 p-3 mb-3"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "h5 mb-3 text-white" }, "Quick Search", -1)
const _hoisted_5 = {
  class: "quick-search",
  action: ""
}
const _hoisted_6 = { class: "input-group" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-lighter btn-disabled",
  type: "button",
  id: "quicksearch-form-button"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search text-dark" })
], -1)
const _hoisted_8 = {
  id: "search-results",
  class: "mt-3"
}
const _hoisted_9 = { class: "list-group-item bg-dark text-light" }
const _hoisted_10 = ["href"]
const _hoisted_11 = {
  id: "promo-slider",
  class: "carousel carousel-dark slide mb-3"
}
const _hoisted_12 = { class: "carousel-indicators" }
const _hoisted_13 = ["data-bs-slide-to"]
const _hoisted_14 = { class: "carousel-inner" }
const _hoisted_15 = {
  class: "carousel-control-prev",
  type: "button",
  "data-bs-target": "#promo-slider",
  "data-bs-slide": "prev"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", {
  class: "carousel-control-prev-icon",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Previous", -1)
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = {
  class: "carousel-control-next",
  type: "button",
  "data-bs-target": "#promo-slider",
  "data-bs-slide": "next"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", {
  class: "carousel-control-next-icon",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Next", -1)
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = { class: "col-12 col-lg-9" }
const _hoisted_24 = {
  key: 0,
  class: "hidden-xs mb-3"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-2" }, "Equipment Categories", -1)
const _hoisted_26 = { class: "row row-cols-2 row-cols-lg-4 g-3" }
const _hoisted_27 = { class: "card card-category" }
const _hoisted_28 = ["src", "alt"]
const _hoisted_29 = { class: "card-label" }
const _hoisted_30 = {
  key: 0,
  class: "promo bg-secondary"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "py-3" }, null, -1)
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "mb-2" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { class: "row row-cols-1 row-cols-lg-3 g-3" }
const _hoisted_36 = {
  key: 0,
  class: "loading"
}
const _hoisted_37 = {
  key: 0,
  class: "overlay"
}
const _hoisted_38 = {
  key: 2,
  class: "mb-4"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("a", { href: "/contact-us" }, "Contact us", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "py-3" }, null, -1)
const _hoisted_41 = {
  key: 3,
  class: "actions text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CardPromo = _resolveComponent("CardPromo")!
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CardEq = _resolveComponent("CardEq")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.state.cards.length > 0)
        ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("form", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
                  type: "text",
                  class: "form-control",
                  placeholder: "Search by typing category, brand, model"
                }, null, 512), [
                  [_vModelText, _ctx.searchQuery]
                ]),
                _hoisted_7
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.searchResults.results), (list) => {
                return (_openBlock(), _createElementBlock("ul", {
                  key: list,
                  class: "list-group bg-white mb-3"
                }, [
                  (_ctx.searchResults.results[list])
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("li", _hoisted_9, _toDisplayString(list), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults.results[list].results, (r) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: r.url,
                            class: "list-group-item"
                          }, [
                            _createElementVNode("a", {
                              href: r.url
                            }, _toDisplayString(r.title), 9, _hoisted_10)
                          ]))
                        }), 128))
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("section", null, [
        _withDirectives(_createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.promos, (p, index) => {
              return (_openBlock(), _createElementBlock("button", {
                key: p.id,
                type: "button",
                class: _normalizeClass({ active : index == 0}),
                "data-bs-target": "#promo-slider",
                "data-bs-slide-to": index
              }, null, 10, _hoisted_13))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.promos, (p, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: p.id,
                class: _normalizeClass(["carousel-item", {active: index == 0}])
              }, [
                _createVNode(_component_CardPromo, { promo: p }, null, 8, ["promo"])
              ], 2))
            }), 128))
          ]),
          _withDirectives(_createElementVNode("button", _hoisted_15, _hoisted_18, 512), [
            [_vShow, _ctx.state.promos.length > 1]
          ]),
          _withDirectives(_createElementVNode("button", _hoisted_19, _hoisted_22, 512), [
            [_vShow, _ctx.state.promos.length > 1]
          ])
        ], 512), [
          [_vShow, _ctx.state.promos.length]
        ])
      ]),
      _createVNode(_component_Sidebar, {
        brand: _ctx.state.brand,
        category: _ctx.state.category,
        subcategories: _ctx.state.subcategories,
        filters: _ctx.state.filters
      }, null, 8, ["brand", "category", "subcategories", "filters"])
    ]),
    _createElementVNode("div", _hoisted_23, [
      (_ctx.state.subcategories.length)
        ? (_openBlock(), _createElementBlock("section", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.subcategories, (c) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: c.id,
                  class: "col"
                }, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("img", {
                      class: "card-img-top",
                      src: c.img || '/static/img/coming-soon-300x200.png',
                      alt: c.name
                    }, null, 8, _hoisted_28),
                    _createElementVNode("div", _hoisted_29, _toDisplayString(c.name), 1),
                    _createVNode(_component_router_link, {
                      class: "stretched-link",
                      to: c.url
                    }, null, 8, ["to"]),
                    (c.promo)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_30, "PROMO"))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ]),
            _hoisted_31
          ]))
        : _createCommentVNode("", true),
      (_ctx.state.cards.length > 0)
        ? (_openBlock(), _createElementBlock("section", _hoisted_32, [
            _createElementVNode("h3", _hoisted_33, [
              _createTextVNode(_toDisplayString(_ctx.state.count) + " result", 1),
              (_ctx.state.count != 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_34, "s"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_35, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.cards, (c) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: c,
                  class: "col"
                }, [
                  _createVNode(_component_CardEq, {
                    name: c.name,
                    url: c.url,
                    type: c.type,
                    img: c.img,
                    details: c.details,
                    promo: c.promo
                  }, null, 8, ["name", "url", "type", "img", "details", "promo"])
                ]))
              }), 128))
            ]),
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _createVNode(_component_ProgressSpinner),
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_37))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("section", _hoisted_38, [
            _createElementVNode("p", null, [
              _createTextVNode("Currently there is no inventory for " + _toDisplayString(_ctx.state.category?.name) + ". ", 1),
              _hoisted_39,
              _createTextVNode(" to discuss your needs.")
            ])
          ])),
      _hoisted_40,
      (!_ctx.loading && _ctx.state.page < _ctx.state.pages)
        ? (_openBlock(), _createElementBlock("p", _hoisted_41, [
            _createElementVNode("a", {
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.loadNextPage && _ctx.loadNextPage(...args)), ["prevent"])),
              class: "btn btn-outline-dark"
            }, "Load More...")
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_Toast)
    ])
  ]))
}